import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class V3SkuGroupsDataSourceService {
  baseUrl = `${environment.v3BaseUrl}/api/v3/admin-desktop/sku-groups`;
  constructor(
    private http: HttpClient
  ) { }

  searchSkuGroups(search: string) {
    return this.http.get(`${this.baseUrl}?search=${search}`).pipe(
      map((response: any) => {
        const mapped: string[] = response.map(item => item.sku).sort((a, b) => a.localeCompare(b));
        return [... new Set(mapped)];
      })
    );
  }
}
